import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isTransporter from "../middlewares/isTransporter";
import hasFinancierPermission from "../middlewares/hasPermission/hasFinancierPermission";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";
import hasTrackingPermission from "@/http/routes/middlewares/hasPermission/hasTrackingPermission";
import userPermission from "@/util/valueObjects/userPermission";

Route.group({}, () => {
  Route.group({ prefix:"logistic_manager",beforeEnter: [isAuthenticated,hasIntegraPermission]}, () => {

  Route.group({prefix: "transporter", beforeEnter: [isTransporter]}, () => {

      Route.redirect("/", to => {
        return {name: "transporter.order_proposals"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/Dashboard/Dashboard.vue")
      ).name("transporter.dashboard");

      Route.group({prefix: "notification"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/notification/NotificationList.vue")
        ).name("transporter.notification");
      })

      Route.group({prefix: "configuration"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/configuration/Configuration")
        ).name("transporter.configuration")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/onboarding", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/configuration/FirstConfiguration/FirstConfiguration.vue")
        ).name("transporter.onboarding")
          .options({
            meta: {
              layout: () =>
                import(/* webpackChunkName: "transporter" */ "src/resources/views/guest/layout/FinanceLayout.vue")
            }
          });
      })

      /*---------------------------------------------------------------------------------------------------------------
        |                                               USERS                                                          |
        ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/user/UserList")
        ).name("transporter.user");
        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/user/UserCreate")
        ).name("transporter.user_create");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/user/UserUpdate")
        ).name("transporter.user_update");
      });

      /*----------------------------------------------------------------------------------------------------------------
      |                                               SUBSIDIARY                                                        |
      -----------------------------------------------------------------------------------------------------------------*/

      Route.group({prefix: "subsidiary"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/transporter/subsidiary/SubsidiaryList")
        ).name("transporter.subsidiary")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });
        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/transporter/subsidiary/SubsidiaryCreate")
        ).name("transporter.subsidiary_create")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/transporter/subsidiary/SubsidiaryUpdate")
        ).name("transporter.subsidiary_update")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               PROPOSALS                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "proposals"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderProposals")
        ).name("transporter.order_proposals");
        Route.view("/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/transporter/order/OrderDetails")
        ).name("transporter.order_proposals_details");
      });
      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes_transporter"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderQuotesTransporter")
        ).name("transporter.order_quotes_transporter");
        Route.view("/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetailsTransporter")
        ).name("transporter.order_quotes_transporter_details");
      });

      Route.view("/shipping_request_quote", () =>
        import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/ShippingRequestQuote")
      ).name("transporter.order_shipping_request_quote");

      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES REQUESTER                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderQuotes")
        ).name("transporter.order_quotes");
        Route.view("/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetails")
        ).name("transporter.order_quotes_details");
        Route.view("/transporters/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetailsTransporterRequester")
        ).name("transporter.order_quotes_details_transporters");
      });
      /*---------------------------------------------------------------------------------------------------------------
      |                                               ORDER                                                          |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "order"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderList")
        ).name("transporter.order");

        Route.view("/orders_documents", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrdersDocuments")
        ).name("transporter.orders_documents");

        Route.view("/exports", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/Exports")
        ).name("transporter.orders_exports");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderUpdate")
        ).name("transporter.order_update");

      });
      Route.view("/import_cte", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/components/ImportCte/CteImport")
      ).name("transporter.import_cte");
      Route.view("/not_imported_files", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/components/InvoiceFiles/NotImportedFilesList")
      ).name("transporter.not_imported_files");

      Route.group({prefix: "driver"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/driver/DriverList")
        ).name("transporter.driver");

        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/driver/DriverCreate")
        ).name("transporter.driver_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/driver/DriverUpdate")
        ).name("transporter.driver_update");

      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                             PURCHASE ORDER                                                    |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "purchase_order"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/purchaseOrder/PurchaseOrderList")
        ).name("transporter.purchase_order")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value, userPermission.INTEGRA_MANAGER__FINANCIER.value]
            }
          });

        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/purchaseOrder/PurchaseOrderDetails")
        ).name("transporter.purchase_order_details")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value, userPermission.INTEGRA_MANAGER__FINANCIER.value]
            }
          });

      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                             Faturas                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "bill"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/bill/billList.vue")
        ).name("transporter.bill");

      });


       //! -------------------------------- ROUTE FOR API -------------------------

       Route.group({prefix: "config_status_apis"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/statusApi/StatusApiList")
        ).name("transporter.config_status_api");

        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/statusApi/StatusApiCreate")
        ).name("transporter.config_status_api_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/statusApi/StatusApiUpdate")
        ).name("transporter.config_status_api_update");
      });

      //! -------------------------------- ROUTE FOR API ----------------------------

      //! -------------------------------- SIMULATION INTEGRA / TAXAS -------------------------

      Route.group({prefix: "simulation_integra"}, () => {
        Route.view("/tables", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/simulationIntegra/SimulationIntegraTables")
        ).name("transporter.simulation_integra.tables");

        Route.view("/approve_table", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/SimulationIntegraApproveTable")
        ).name("transporter.simulation_integra.approve_table");
      });

      //! -------------------------------- SIMULATION INTEGRA / TAXAS ----------------------------

      //! -------------------------------- ROUTE TABLE / TAXAS -------------------------

      Route.group({prefix: "route_table"}, () => {
        Route.view("/approve_table", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/ApproveRouteTable")
        ).name("transporter.approve_route_table");
      });

      //! -------------------------------- ROUTE TABLE / TAXAS ----------------------------

    });

  });
});

export default Route.all();
